import React, { useRef } from 'react';
import { URLS } from '@wix/da-url';
import { BiData, DefaultBiEvent } from '@wix/da-bi/pkg/events';
import { useMeasuredCookie } from '@wix/da-shared-react/pkg/Measured/useMeasuredCookie';
import { PapiDeviation } from '@wix/da-papi-types';
import AdoptableShopCard from '@wix/da-shared-react/pkg/ShopCard/AdoptableShopCard';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider.v2';
import { ShopItemType } from '../../../../../../../types/shop';
import UploadMore from '../../../_partials/UploadMore';

interface Props {
  showAddItemCard?: boolean;
  deviations: PapiDeviation[];
}

const AdoptableSliderMobile: React.FC<Props> = ({
  showAddItemCard,
  deviations,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const measuredContainer = useMeasuredCookie(undefined, containerRef, {
    cookieDim: 'width',
  });

  const DEFAULT_CARD_WIDTH = 320;
  const DEFAULT_CARD_HEIGHT = 292;

  const cardWidthMobile = measuredContainer?.width ?? DEFAULT_CARD_WIDTH;

  return (
    <div ref={containerRef}>
      <SwipeSlider startSlide={showAddItemCard ? 1 : 0}>
        {showAddItemCard && (
          <UploadMore
            itemType={ShopItemType.ADOPTABLES}
            height={DEFAULT_CARD_HEIGHT}
            biData={BiData<DefaultBiEvent>({
              evid: 2,
              click_info: 'create_adoptable',
              sectionname: 'adoptable',
            })}
            onCreate={() => window.location.replace(URLS.SUBMIT)}
          />
        )}
        {deviations.map(deviation => (
          <AdoptableShopCard
            key={deviation.deviationId}
            width={cardWidthMobile}
            deviation={deviation}
            withAuthorDetails={false}
            withIndicators={false}
            withOwnerDetails
          />
        ))}
      </SwipeSlider>
    </div>
  );
};
AdoptableSliderMobile.displayName = 'AdoptableSliderMobile';

export default AdoptableSliderMobile;
